module.exports = __webpack_public_path__ + "static/media/icons8-mysql-logo - Copy.08e81e22.svg";